//=================================================
// Sliders
//=================================================
import { createInitializeOnce } from './utilities';

const initializeOnce = createInitializeOnce();

export default function setupSliders() {
    document.querySelectorAll('.slider').forEach((slider) => {
        if (initializeOnce(slider)) {
            const sliderList = slider.querySelector('.slider__list');
            const prevBtn = slider.querySelector('.slider__arrow--prev');
            const nextBtn = slider.querySelector('.slider__arrow--next');

            // Some sliders (e.g. teen groups) render without a list element
            if (!sliderList) return;

            // If content doesn't overflow arrows can be hidden
            const updateArrows = () => {
                const needsScroll = sliderList.scrollWidth > sliderList.clientWidth;
                slider.classList.toggle('no-arrows', !needsScroll);
            };

            // Re-evaluate arrow visibility on resize, cleaning up once the slider leaves the DOM
            const resizeHandler = () => {
                if (!slider.isConnected) {
                    window.removeEventListener('resize', resizeHandler);
                    return;
                }
                updateArrows();
            };
            window.addEventListener('resize', resizeHandler);

            updateArrows();

            if (!prevBtn || !nextBtn) return;

            const updateButtons = () => {
                const scrollLeft = sliderList.scrollLeft;
                const maxScroll = sliderList.scrollWidth - sliderList.clientWidth;

                prevBtn.disabled = scrollLeft <= 1;
                nextBtn.disabled = scrollLeft >= maxScroll - 1;
            };

            const scrollByItem = (direction) => {
                const item = sliderList.querySelector('.slider-item');
                if (!item) return;

                const itemWidth = item.offsetWidth;
                const gap = parseInt(getComputedStyle(sliderList).gap) || 0;
                const scrollAmount = itemWidth + gap;

                sliderList.scrollBy({
                    left: direction === 'next' ? scrollAmount : -scrollAmount,
                    behavior: 'smooth'
                });
            };

            prevBtn.addEventListener('click', () => scrollByItem('prev'));
            nextBtn.addEventListener('click', () => scrollByItem('next'));
            sliderList.addEventListener('scroll', updateButtons);

            updateButtons();
        }
    });
}
